<div class="messages-container">
  <!-- Search Message - Keep as is -->
  <p class="text-center mat-body-1" *ngIf="form?.searchMessage">
    {{ form.searchMessage }}
  </p>
  <!-- Success Alert - Material Card -->
  <div *ngIf="form?.['error'] === false && form?.['message']">
    <mat-card appearance="outlined" class="success-alert mt-2">
      <mat-card-content class="alert-content">
        <div class="alert-content-wrapper">
          <mat-icon class="alert-icon">check_circle</mat-icon>
          <span class="mat-body-1">{{ form["message"] }}</span>
        </div>
      </mat-card-content>
      <button
        mat-icon-button
        class="alert-dismiss icon-pd-none"
        (click)="clearMessage()"
      >
        <mat-icon class="icon-compact">close</mat-icon>
      </button>
    </mat-card>
  </div>

  <!-- Error Alert - Material Card -->
  <div *ngIf="form?.['error'] === true && form?.['message']">
    <mat-card appearance="outlined" class="error-alert mt-2">
      <mat-card-content class="alert-content">
        <div class="alert-content-wrapper">
          <mat-icon class="alert-icon">error</mat-icon>
          <span class="mat-body-1">{{ form["message"] }}</span>
        </div>
      </mat-card-content>
      <button
        mat-icon-button
        class="alert-dismiss icon-pd-none"
        (click)="clearMessage()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card>
  </div>
</div>

<!-- Material Table Component -->
<app-table-row-editor
  [dataList]="form?.['list'] || []"
  [activeColumns]="activeColumns"
  [dropdownOptions]="getDropdownOptions()"
  [columnLabels]="getColumnLabel()"
  (onSave)="handleSave($event)"
  (onUpdate)="handleUpdate($event)"
  (onDelete)="handleDelete($event)"
  [nonEditableColumns]="getNonEditableColumns()"
>
</app-table-row-editor>